// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ControlPanel, ControlPanelLocation, ControlPanelType} from "@models";
import {NotificationService, SimUserInterfaceService, SimWindowService} from "@services";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {Translations} from "@translations";
import {EnumLabel} from "../../../../../shared/shared-pipes/enum-label.pipe";

export interface DialogData_PanelConfigurationDialogInput extends MatDialogDataBaseInput {
	panels: ControlPanel[];

	controlPanelLocation: ControlPanelLocation;
}

export interface DialogData_PanelConfigurationDialogOutput extends MatDialogDataBaseOutput {}

@UntilDestroy()
@Component({
	selector: "sim-panel-configuration-dialog",
	templateUrl: "./panel-configuration-dialog.component.html",
	styleUrls: ["./panel-configuration-dialog.component.scss"],
	standalone: false,
})
export class PanelConfigurationDialogComponent extends BasicMaterialDialog<
	PanelConfigurationDialogComponent,
	DialogData_PanelConfigurationDialogInput,
	DialogData_PanelConfigurationDialogOutput
> {
	T = Translations;
	ControlPanelType = ControlPanelType;
	EnumLabel = EnumLabel;
	public isTwoScreen: boolean;

	ControlPanelLocation = ControlPanelLocation;

	constructor(
		_injector: Injector,
		private _simUserInterfaceService: SimUserInterfaceService,
		private _NotificationService: NotificationService,
		private _simWindowSerevice: SimWindowService,
	) {
		super(_injector);

		this._simWindowSerevice.isTwoScreen.pipe(untilDestroyed(this)).subscribe((result: boolean) => {
			this.isTwoScreen = result;
		});
	}

	togglePanelHiddenClicked(panel: ControlPanel) {
		panel.isHidden = !panel.isHidden;

		this._simUserInterfaceService
			.setControlPanelHiddenState({
				controlPanelId: panel.id,
				isHidden: panel.isHidden,
			})
			.then((result) => {
				if (!result) {
					this._NotificationService.notifyError(`Could not save the hidden state of panel '${panel.id}'`);
				}
			});
	}

	orderPanel($event: CdkDragDrop<ControlPanel>) {
		moveItemInArray(this.data.panels, $event.previousIndex, $event.currentIndex);

		this._simUserInterfaceService.setPanelOrder({
			controlPanelIds: this.data.panels.map((panel) => panel.id),
		});
	}

	dockAllPanels() {
		this._simUserInterfaceService.restorePanels(this.data.controlPanelLocation).then(() => {
			//Do it manually again in order to keep the dock animation
			this.data.panels.forEach((panel) => {
				panel.undocked = false;
				panel.isOpen = false;
				if (panel.type === ControlPanelType.Annotation) {
					switch (this.data.controlPanelLocation) {
						case ControlPanelLocation.Recorder:
							panel.isOpen = true;
							break;
						case ControlPanelLocation.Tablet:
							panel.isOpen = true;
							break;
						case ControlPanelLocation.ParticipationView:
							panel.isOpen = true;
							break;
					}
				}
				panel.isHidden = false;
			});
		});
	}
}
